/* eslint-disable react/no-danger */
import React from 'react';
import './HeaderWithVideo.scss';

const HeaderWithVideo = ({ content }) => (
  <section className='page-header page-header--technology'>
    <div className='page-header__overlay' />
    <div className='wrapper-fluid HeaderWithVideo'>
      <div className='HeaderContent'>
        <div className='HeaderContent__title'>
          <h1 dangerouslySetInnerHTML={{ __html: content.title }} />
          <p>{content.description}</p>
        </div>
      </div>
      <div className='HeaderVideo'>
        <div className='HeaderVideo__iframe'>
          <iframe className='video_iframe' src={content.video} title='video-modal' />
        </div>
      </div>
    </div>
  </section>
);

export default HeaderWithVideo;
